import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlLocatorService, AIMSClient } from '@al/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'initiate-password-reset',
  templateUrl: './initiate-password-reset.component.html',
  styleUrls: ['./initiate-password-reset.component.scss']
})
export class InitiatePasswordResetComponent implements OnInit {

    public emailAddress:string;
    public state:string = "reset";
    public returnUrl:string;
    public errorMessage:string = "";

    constructor( public router:Router,
                 private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.initialize();
    }

    initialize = () => {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.returnUrl = params['return_to'];
            this.emailAddress = params['email'];
        });
    }

    onKeyDown = async (event) => {
        if (event.keyCode === 13) {
           await this.onResetPassword();
        }
    }

    /** When user click on the reset password button */
    onResetPassword = async () => {
        this.state = "loading";
        let returnTo = this.returnUrl ? this.returnUrl : AlLocatorService.resolveURL( "cd17:accounts", "" );
        if (!this.emailAddress) {
            this.manageErrors("Invalid username.");
            return
        }
        if (!returnTo) {
            this.manageErrors("Invalid return to parameter.");
            return
        }
        try {
            await AIMSClient.initiateReset(this.emailAddress, returnTo);
            this.state = "sent";
            this.closeMessageError();
        } catch (error) {
            this.state = "reset";
            this.manageErrors(error.data.error);
        }
    }

    /** When user click on the return to login button */
    onReturnToLogin = () => {
        window.location.href = this.sanitizeRedirectUrl(this.returnUrl);
    }

    /**
     * verifies that redirect URL is allowed, otherwise, return a default valid
     * redirect url
     * @param  \{string\} redirectUrl URL to verify
     * @return \{string\} valid redirect URL
     */
    sanitizeRedirectUrl = (redirectUrl) => {
        let regexValidator = new RegExp('.+\.alertlogic\.com$');
        let belongsToAlertlogic = regexValidator.test(this.returnUrl);
        // whitelist redirect url before redirects
        // this validation needs to apply only in production because in dev/local
        // we use localhost:<port> domain
        if(!belongsToAlertlogic && this.isProductionEnv()){
            return AlLocatorService.resolveURL( "cd17:accounts" );
        }
        return redirectUrl;
    }

    isProductionEnv = () => {
        return environment.production;
    }

    /** Manage the errors */
    manageErrors = ( error:any ) => {
        let message = "An internal error occurred while saving your information. Please try again.";
        if (error === 'weak_password') {
            message = "You must choose a strong password. Please review our password policy and try again.";
        }else if (error === 'password_reuse_prevented') {
            message = "Cannot update user information, because the password was already used.";
        }else if (error === 'unauthorized') {
            message = "Alert Logic could not authenticate your credentials.";
        }

        this.showErrorMsg(message);
    }

    /** Show an error message */
    showErrorMsg = ( msg:any ) => {
        // TODO: replace this for the notification panel
        this.errorMessage = msg;
    }

    /** Close error message */
    closeMessageError = () => {
        this.errorMessage = "";
    }
}
